import { useEffect, useRef, useState } from "react";

/**
 * Reveal an element with fade + translateY when it enters the viewport.
 * Returns ref to attach + a className helper.
 */
export const useScrollReveal = (options = {}) => {
  const { threshold = 0.15, once = true } = options;
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          if (once) observer.unobserve(el);
        } else if (!once) {
          setVisible(false);
        }
      },
      { threshold }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, once]);

  return { ref, visible };
};
